import { ctw } from '@/common';

// Call status and call outcome share a vocabulary ("failed" is valid for both)
// and the mocks give the shared values the same colour, so one map serves both.
const CALL_PILL_STYLES: Record<string, string> = {
  completed: 'bg-green-100 text-green-700',
  success: 'bg-green-100 text-green-700',
  failed: 'bg-red-100 text-red-600',
  cancelled: 'bg-gray-100 text-gray-500',
  inconclusive: 'bg-gray-100 text-gray-500',
};

const NA_PILL_STYLES = 'bg-gray-100 text-gray-400';

// An absent status or outcome renders "N/A" rather than an empty slot — a
// cancelled or failed call legitimately has no outcome.
export const CallPill = ({ value }: { value?: string | null }) => (
  <span
    className={ctw(
      'inline-flex w-fit items-center rounded-sm px-2 py-0.5 text-sm font-medium uppercase',
      value ? (CALL_PILL_STYLES[value] ?? NA_PILL_STYLES) : NA_PILL_STYLES,
    )}
  >
    {value ?? 'N/A'}
  </span>
);
